import { containsOnlyWhiteSpaces } from './string';

export const validatePhone = (
  phone: string,
  {
    isRequired,
  }: {
    isRequired: {
      enabled: boolean;
      message?: string;
    };
  },
): string | undefined => {
  if (isRequired.enabled && (!phone || containsOnlyWhiteSpaces(phone))) {
    return isRequired.message || 'Por favor, introduce un número de teléfono';
  }
  if (!isRequired.enabled && (!phone || containsOnlyWhiteSpaces(phone))) return;

  let valid = false;

  valid = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(phone);

  if (!valid) {
    return 'Por favor, utiliza un teléfono válido';
  } else {
    return;
  }
};
